import CONSTANTS from './constants';


const {
    PAGE,
    PAGE_INFO,
    PAGE_TYPE,
    PAGE_NAME,
    CATEGORY,
    PRIMARY_CATEGORY,
    SUB_CATEGORY1,
    SUB_CATEGORY2,
    ERROR,
    EVENT_NAME,
    EVENT_INFO,
    EVENT_MODE,
    SETTINGS,
    MY_ACCOUNT,
    STASH,
} = CONSTANTS;



const createError = function (type, displayType, pageSection, message, code) {
    return {
        [CONSTANTS.TYPE]: type,
        [CONSTANTS.DISPLAY_TYPE]: displayType,
        [CONSTANTS.PAGE_SECTION]: pageSection,
        [CONSTANTS.MESSAGE]: message,
        [CONSTANTS.CODE]: code,
    };
};

const createThdAnalyticEventInfo = function (eventName, eventCategory) {
    return {
        [EVENT_INFO]: { [EVENT_NAME]: eventName },
        [CATEGORY]: { [PRIMARY_CATEGORY]: eventCategory },
    };
};

const createThdAnalyticEvent = function (eventName, eventCategory) {
    return {
        [EVENT_INFO]: { [EVENT_NAME]: eventName },
        [CATEGORY]: { [PRIMARY_CATEGORY]: eventCategory },
        [ERROR]: []
    }

};

const createThdAnalyticEventUnenroll = function (eventName, eventCategory, myAccountSettings) {
    return {
        [EVENT_INFO]: { [EVENT_NAME]: myAccountSettings },
        [CATEGORY]: { [PRIMARY_CATEGORY]: eventCategory },
        ['myAccount']: { 'settings': eventName },
        [ERROR]: []
    }

};

const createErrorThdAnalyticEventPostPage = function () {
    return {
        [EVENT_INFO]: { 
            [EVENT_NAME]: "post page error" ,
            [ERROR]: [],
        },
        [CATEGORY]: { [PRIMARY_CATEGORY]: "error" },
    }

};

const createErrorThdAnalyticEventPageLoad = function () {
    return {
        [EVENT_INFO]: {
            [EVENT_NAME]: "page load error",
            [ERROR]: [],
        },
        [CATEGORY]: { [PRIMARY_CATEGORY]: "error" },
    }

};


/**
 * Push the event info to the DDO object
 */
const pushEventInfo = function (analyticsEvent) {
    try {
        if (analyticsEvent) {
            console.log("sending event", analyticsEvent)
            window.digitalData.event.push(analyticsEvent);
        }
        console.log("pushEventInfo");
    } catch (err) {
        // Suppressing the DDO error, so that functionality is not affected
        console.error('DDO : Error in pushing the event info!!!');
    }
};

const fireOpenNewAddressOverlayEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("instant checkout new address", "overlay"));
};

const fireOpenNewCardOverlayEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("instant checkout new credit card", "overlay"));
};

const fireOpenEditAddressOverlayEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("instant checkout edit address", "overlay"));
};

const fireOpenEditCardOverlayEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("instant checkout edit credit card", "overlay"));
};

const fireOpenLeaveOverlayEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("leave instant checkout setup", "overlay"));
};

const fireEnrolledEvent = function () {
    pushEventInfo(createThdAnalyticEventInfo("instant checkout enrolled", "button submission"));
};

const fireUnenrolledEvent = function () {
    pushEventInfo(createThdAnalyticEventUnenroll("instant checkout unenrolled", "button submission", "my account settings"));
};


const constructErrorEvent = function(event, error, config) {

    let isAPIError = !!(error && error.response && error.response.data);
    
    if (isAPIError) {

        let resp = error.response.data;
        let errors = [];
        if (resp.errors) {
            errors = resp.errors;
        } else if (resp.account && resp.account.errors) {
            errors = resp.account.errors;
        } else if (resp.addresses && resp.addresses.errors) {
            errors = resp.addresses.errors;
        } else if (resp.paymentCards && resp.paymentCards.errors) {
            errors = resp.paymentCards.errors;
        }
        else {
            errors = [];
            errors.push({
                errorMessage: JSON.stringify(resp)
            });
        }
        errors.forEach((value) => {
            let code = value.errorCode || error.response.status || "";
            let message = config.message || value.errorMessage || "";
            let type = 'system';
            let displayType = config.type || "page";
            let pageSection = config.pageSection || "page level";

            if (code === 'PYMTCRD_ERR_132') {
                type = "error";
            }

            let err = createError(type, displayType, pageSection, message, code);
            event.eventInfo.error.push(err);
        });
    } else {
        let type = 'system';
        let code = config.code ||error.response.status || "unknownerr";
        let message = config.message || "";
        let displayType = config.type || "page";
        let pageSection = config.pageSection || "page level";
        if (error instanceof Error) {
            message = config.message || error.toString();
            let err = createError(type, displayType, pageSection, message, code);
            event.eventInfo.error.push(err);
        } else {
            message = config.message || '';
            let err = createError(type, displayType, pageSection, message, code);
            event.eventInfo.error.push(err);
        }
    }
    return event;
}

const firePageLoadError = function (error, config) {
    try {
        let event = createErrorThdAnalyticEventPageLoad();
        config = config || {};
        event = constructErrorEvent(event, error, config);
        pushEventInfo(event);
    } catch (err) {
    }
  
};

const firePageLevelError = function(error, config) {
    try {
        let event = createErrorThdAnalyticEventPostPage();
        config = config || {};
        event = constructErrorEvent(event, error, config);
        pushEventInfo(event);
    } catch (err) {
    }
};

const AnalyticEvents = {
    createError,
    createThdAnalyticEvent,
    createErrorThdAnalyticEventPostPage,
    createErrorThdAnalyticEventPageLoad,
    pushEventInfo,
    fireOpenNewAddressOverlayEvent,
    fireOpenNewCardOverlayEvent,
    fireOpenEditAddressOverlayEvent,
    fireOpenEditCardOverlayEvent,
    firePageLoadError,
    firePageLevelError,
    fireOpenLeaveOverlayEvent,
    fireEnrolledEvent,
    fireUnenrolledEvent
};

export { AnalyticEvents };


// WEBPACK FOOTER //
// ./src/analytics/ddo.js